import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';

export const redirectAuthenticatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (state.url.startsWith('/auth/reset-password')) {
    return true;
  }

  if (authService.isLoggedIn()) {
    // Already authenticated — redirect to dashboard
    router.navigate(['/inicio']);
    return false;
  }

  return true; // Not authenticated — allow login page
};
